import { render, staticRenderFns } from "./examForm.html?vue&type=template&id=04a7c50e&external"
import script from "./examForm.vue?vue&type=script&lang=js"
export * from "./examForm.vue?vue&type=script&lang=js"
import style0 from "./examForm.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports